document.addEventListener('DOMContentLoaded', () => {
  // === Popup-Container ===
  const popup = document.createElement('div');
  popup.className = 'image-preview-popup';
  Object.assign(popup.style, {
    display: 'none',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: '10000',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
    padding: '16px',
    paddingTop: '56px', // Platz für Header oben
    maxWidth: '98vw',
    maxHeight: '98vh',
    overflow: 'auto',
    flexDirection: 'column',
    alignItems: 'center',
  });
  document.body.appendChild(popup);

  // === Overlay ===
  const overlay = document.createElement('div');
  overlay.className = 'image-preview-overlay';
  Object.assign(overlay.style, {
    display: 'none',
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.7)',
    zIndex: '9999',
  });
  document.body.appendChild(overlay);

  // === Header (Text + Close-Button) ===
const header = document.createElement('div');
Object.assign(header.style, {
  position: 'absolute',
  top: '12px',
  left: '16px',
  right: '16px',
  display: 'grid',
  gridTemplateColumns: '1fr auto 1fr', // links Platz, Mitte Text, rechts Button
  alignItems: 'center'
});
popup.appendChild(header);

// Hinweistext
const notice = document.createElement('p');
notice.textContent = 'Diese Vorschau ist in geringerer Auflösung dargestellt. Der Bildausschnitt und das Design entsprechen der finalen Druckdatei.';
notice.className = 'preview-popup-hint';
Object.assign(notice.style, {
  margin: '0',
  lineHeight: '1.2',
  fontSize: '14px',
  gridColumn: '2',     // immer in der Mitte
  textAlign: 'center',
  whiteSpace: 'normal' // falls der Text umbrechen darf
});
header.appendChild(notice);

// Close-Button oben rechts (auf Text-Höhe)
const closeButton = document.createElement('button');
closeButton.type = 'button';
closeButton.innerHTML = '×';
closeButton.setAttribute('aria-label', 'Vorschau schließen');
Object.assign(closeButton.style, {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  //width: '32px',
  height: '32px',
  lineHeight: '1',
  fontSize: '24px',
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  color: '#000',
  gridColumn: '3',     // rechts
  justifySelf: 'end'   // nach ganz rechts
});
header.appendChild(closeButton);

  // === Bild ===
  const popupImage = document.createElement('img');
  Object.assign(popupImage.style, {
    display: 'block',
    maxWidth: '100%',
    height: 'auto',
    borderRadius: '4px',
  });
  popup.appendChild(popupImage);

  // === Buttons für Vorschau ===
  document.querySelectorAll('.preview-image-button').forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();

      const imageUrl = button.getAttribute('data-image');
      if (imageUrl) {
        popupImage.src = imageUrl;

        popupImage.onload = () => {
          const isLandscape = popupImage.naturalWidth > popupImage.naturalHeight;
          popupImage.style.maxWidth = isLandscape ? '98vw' : '90vw';
          popupImage.style.maxHeight = isLandscape ? '90vh' : '98vh';

          popup.style.display = 'flex';
          overlay.style.display = 'block';
        };
      }
    });
  });

  // === Schließen-Funktion ===
  function closePopup() {
    popup.style.display = 'none';
    overlay.style.display = 'none';
  }

  // === Klick-Events zum Schließen ===
  overlay.addEventListener('click', closePopup);
  closeButton.addEventListener('click', closePopup);
});
